import { useState } from 'react';
import pdf from './terms.pdf';
import { Viewer } from '@react-pdf-viewer/core';
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';




export default function PDFComp() {
    

  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess ({numPages}) {
    setNumPages(numPages);
  }

  

  return (
    <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js">
        <div style={{
        border: '1px solid rgba(0, 0, 0, 0.3)',
        height: '750px',
    }}>
<Viewer fileUrl={pdf} />
        </div>
        

</Worker>
  );
}